module.exports = __webpack_public_path__ + "img/LEAD.917f8498.svg";